/*
 * @Description:
 * @Date: 2022-05-31 16:50:30
 */
import createExtend from '@/components/createExtend.js';
import subAccountMgmt from '@/page/home/child/subAccountMgmt';
import { setStorage } from '@/tools/storage';
import vue2Store from '@/store/index';
import { indexInfo, invoice } from '@/api/ajax';
import { getAuthStatus } from '@/router/service/getAccountStatus';
export const middlewareHomeProject = {
  setHomeProjectInfo: async (item, customQuery = {}) => {
    // 审核项目，进行下一个项目时需要使用到
    setStorage('home-search-query', customQuery);

    // 跳转详情
    // vue2Store.commit('SET_SEARCHTYPE', businessType);

    // 项目主要参数
    await vue2Store.dispatch('syncProjectInfo', item);

    return {
      ...vue2Store.state.homeProject,
      localCache: ''
    };
  },
  // 让我偷个懒吧，不然要在vue3中重写权限配置弹窗
  powerMgmt(item, onUpdated = () => {}) {
    createExtend(subAccountMgmt, {
      data: item
    }).$on('updated', () => {
      onUpdated && onUpdated();
    });
  },
  // 获取未开票订单数量  和 待支付金额
  async getHomeStatistics() {
    const { showOpenFlag } = await getAuthStatus();
    if (!showOpenFlag) {
      return {
        hideMoneyItem: true,
        hastInvoiceCount: 0, // 未开票金额
        totalOrderPrice: 0 // 待支付金额 = 超时金额+待支付金额
      };
    }
    const [
      {
        data: {
          data: { hastInvoiceCount }
        }
      },
      {
        data: {
          data: { totalOrderPrice: noPayAmount }
        }
      }
    ] = await Promise.all([invoice.invoiceStatistics(), indexInfo()]);
    return {
      hastInvoiceCount, // 未开票金额
      noPayAmount // 待支付金额 = 超时金额+待支付金额
    };
  }
};
